import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { result } from 'lodash-es';
import { ProfileWidgetDto } from '../../shared/dto/profile-widget.dto';
import { ProfileWidgetService } from '../../shared/profile-widget.service';

@Component({
  selector: 'wl-profile-edit-embedded-video',
  templateUrl: './profile-edit-embedded-video.component.html',
  styleUrls: ['./profile-edit-embedded-video.component.less'],
    standalone: false
})
export class ProfileEditEmbeddedVideoComponent implements OnChanges {
  @Input() profileId: number;
  widgetExists: boolean = false;
  profileWidget: ProfileWidgetDto = { Html: '' } as ProfileWidgetDto;
  constructor(private _profileWidgetService: ProfileWidgetService) {}

  ngOnChanges() {
    if (this.profileId) {
      this._profileWidgetService.getProfileWidget(this.profileId).then((result) => {
        if (result.length > 0) {
          this.widgetExists = true;
          this.profileWidget = result[0];
        }
      });
    }
  }

  clear() {
    this.profileWidget.Html = '';
  }

  save(): Promise<void> {
    this.profileWidget.ProfileId = this.profileId;
    if (this.profileWidget.Html.trim() == '' && this.widgetExists) {
      this._profileWidgetService.deleteProfileWidget(this.profileWidget.WidgetId);
      this.widgetExists = false;
      this.profileWidget.WidgetId = null;
    } else if (this.widgetExists) {
      this._profileWidgetService.updateProfileWidget(this.profileWidget.WidgetId, this.profileWidget);
    } else if (!this.widgetExists && this.profileWidget.Html.trim() != '') {
      this._profileWidgetService.createProfileWidget(this.profileWidget).then((result) => {
        this.profileWidget.WidgetId = result;
        this.widgetExists = true;
      });
    }
    return Promise.resolve();
  }
}
